'use client'

import clsx from 'clsx'
import { useRouter, useSearchParams } from 'next/navigation'
import { ChangeEvent, useEffect, useRef } from 'react'

import { Icon } from '@wartek-id/icon'
import { useMedia } from '@wartek-id/react-utils'
import { Select } from '@wartek-id/select'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'
import { Text } from '@wartek-id/text'

import { trackViewMetadata } from '@/utils/tracker/modules/metadata'

import {
  BaseContainerClassName,
  Container,
  DefaultContainerSpacingAsPadding,
} from '@/components/Container'
import { HeadingTitleBlock } from '@/components/HeadingTitleBlock/HeadingTitleBlock'
import { MetadataIcon } from '@/components/Icons/MetadataIcon'

import { METATAG } from '@/configs/constants'

import { MetaDataPanel } from './components/MetaDataPanel'
import { StandardDataPanel } from './components/StandardDataPanel'

export default function MetadataPage() {
  const router = useRouter()
  const searchParams = useSearchParams()

  const mountedRef = useRef<boolean>(false)

  const isMd = useMedia('(min-width: 768px)', false)

  const queryTab = (searchParams?.get?.('tab') as string) || 'standar-data'
  const queryJenis =
    (searchParams?.get?.('jenis') as string) || 'satpen-yayasan'

  const handleChangeTab = (index: number) => {
    const tabName = index === 0 ? 'standar-data' : 'meta-data'
    router.replace(`?tab=${tabName}&jenis=${queryJenis}`, { scroll: false })
  }

  const handleChangeJenis = (newJenis: string) => {
    router.replace(`?tab=${queryTab}&jenis=${newJenis}`, { scroll: false })
  }

  useEffect(() => {
    if (!mountedRef.current) {
      trackViewMetadata()
      mountedRef.current = true
    }
  }, [])

  return (
    <>
      <HeadingTitleBlock
        withIcon={true}
        withFaqText={true}
        withMapOverlay={true}
        icon={<MetadataIcon />}
        title={METATAG.METADATA.title}
        desc={METATAG.METADATA.description}
        trackerGaEventName="metadata"
        trackerPageTitle="Metadata"
      />
      <section id="content-section">
        <section
          id="data-induk-type-section"
          className={clsx('bg-gray-5 py-4')}
        >
          <Container>
            <div>
              <Text variant="body-sm-bold" className="mb-2">
                Pilih Data Induk
              </Text>
              <Select
                value={queryJenis}
                onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                  const newValue = e.target.value
                  handleChangeJenis(newValue)
                }}
                dropdownIcon={<Icon>expand_more</Icon>}
                data-testid="combo-filter-jenis"
                className="!py-2"
              >
                {[
                  {
                    id: 'satpen-yayasan',
                    displayName:
                      'Satuan Pendidikan Dan Badan Penyelenggara (Yayasan)',
                  },
                  {
                    id: 'ptk',
                    displayName: 'Pendidik dan Tenaga Kependidikan',
                  },
                ].map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.displayName}
                  </option>
                ))}
              </Select>
            </div>
          </Container>
        </section>

        <Tabs
          isFitted={isMd}
          selectedIndex={queryTab === 'standar-data' ? 0 : 1}
          onChange={handleChangeTab}
        >
          <TabList
            className={clsx(
              BaseContainerClassName,
              DefaultContainerSpacingAsPadding
            )}
            withBorder
          >
            <Tab data-testid="tab-standar-data">STANDAR DATA</Tab>
            <Tab data-testid="tab-meta-data">METADATA</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <StandardDataPanel jenis={queryJenis} />
            </TabPanel>
            <TabPanel>
              <MetaDataPanel jenis={queryJenis} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </section>
    </>
  )
}
